import { axios1 } from '../instance'

/**
 * 获取菜单
 * @return {Promise}
 */
export const getRolus = () => {
  return axios1.postByJson('/user/menuTree')
}